module.exports = __webpack_public_path__ + "img/hlnm_Android.87236ab3.png";